import type { DeliveryNote, DeliveryNoteRow } from "@shared/delivery-note";
import { invoiceItemSchema, type InvoiceItem } from "@shared/invoice";

export function deliveryRowReady(row: DeliveryNoteRow): boolean {
  return !!row.material.trim() && row.quantity !== null && Number.isFinite(row.quantity) &&
    row.quantity > 0 && row.quantity <= 1e9 && !!row.unit.trim() && row.unit.length <= 40 && row.unitPrice !== null &&
    Number.isFinite(row.unitPrice) && row.unitPrice >= 0 && row.unitPrice <= 1e9;
}

/** Transfer once, with no live link back to a delivery slip or the offer. */
export function applyDeliveryNote(note: DeliveryNote): { note: DeliveryNote; items: InvoiceItem[] } {
  const selected = note.rows.filter((row) => row.selected && !row.appliedItemId);
  if (!selected.length) throw new Error("Bitte mindestens eine noch nicht übernommene Zeile auswählen.");
  if (selected.some((row) => !deliveryRowReady(row))) {
    throw new Error("Bitte für alle ausgewählten Zeilen Material, Menge größer 0, Einheit und einen Netto-Einheitspreis ergänzen. Ein kostenloser Artikel kann ausdrücklich mit 0 € eingetragen werden.");
  }
  const items = selected.map((row): InvoiceItem => ({
    id: crypto.randomUUID(),
    description: [
      row.material.trim(),
      row.articleNumber.trim() ? `Art.-Nr.: ${row.articleNumber.trim()}` : "",
      row.notes.trim(),
    ].filter(Boolean).join("\n"),
    quantity: row.quantity!,
    unit: row.unit.trim(),
    unitPrice: row.unitPrice!,
    billable: true,
    sourceLabel: `Lieferschein ${note.deliveryNumber.trim() || note.fileName}`,
  }));
  if (items.some((item) => !invoiceItemSchema.safeParse(item).success)) {
    throw new Error("Eine Materialbeschreibung ist zu lang für eine Rechnungsposition. Bitte Material und Anmerkung auf zusammen höchstens 10000 Zeichen kürzen.");
  }
  const ids = new Map(selected.map((row, index) => [row.id, items[index].id]));
  return {
    items,
    note: { ...note, rows: note.rows.map((row) =>
      ids.has(row.id) ? { ...row, appliedItemId: ids.get(row.id)!, selected: false } : { ...row }) },
  };
}
